import { IconInfoCircleOutline, IconRocket } from '@iwoca/icons';
import { AlertBox } from '@iwoca/orion';

import { LAUNCH_PACK_URL, STATUS_INFO } from './statusInfoContent';
import { TabKey } from '../../CustomersV2.types';
import { InfoSheet } from '../InfoSheet/InfoSheet';

const StatusRow = ({
  name,
  description,
  information,
}: {
  name: string;
  description: string;
  information: string;
}) => (
  // 32px column gap and the 138px name column come straight from the design;
  // neither is an Orion spacing token.
  <div className="flex gap-[32px] border-b border-secondary-90 px-s py-l last:border-b-0">
    <div className="shrink-0 basis-[138px] text-s font-med text-primary-10">
      {name}
    </div>
    <div className="flex flex-1 flex-col gap-s text-xs font-reg text-primary-10">
      <div>{description}</div>
      <div className="flex gap-xs py-xs">
        <IconInfoCircleOutline height={16} width={16} className="shrink-0" />
        {information}
      </div>
    </div>
  </div>
);

export const StatusInfoModal = ({
  tabKey,
  isOpen,
  onClose,
}: {
  tabKey: TabKey;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { title, rows, launchPackCopy } = STATUS_INFO[tabKey];

  return (
    <InfoSheet
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      closeLabel="Close status information"
      headerClassName="px-l py-xl"
      titleClassName="text-xl"
    >
      <div className="flex flex-col gap-l px-xl py-l">
        <div className="flex flex-col">
          {rows.map((row) => (
            <StatusRow key={row.name} {...row} />
          ))}
        </div>

        <AlertBox
          className="flex gap-s text-s font-reg text-primary-10"
          variant="connect"
        >
          <IconRocket height={20} width={20} className="shrink-0" />
          <div>
            <a
              href={LAUNCH_PACK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="font-bold"
            >
              Launch pack:
            </a>{' '}
            {launchPackCopy}
          </div>
        </AlertBox>
      </div>
    </InfoSheet>
  );
};
